module.exports = __webpack_public_path__ + "0bd2dc8ef1f67cce7a71a20a44f1e6ea.jpg";